export function checkPrivileges(privilege: string) {
    const loggedInUserInfo = JSON.parse(localStorage.getItem('userInfo') as any);
    const loggedInUserPriviliges = loggedInUserInfo?.privileges?.includes(privilege);

    return loggedInUserPriviliges;
}